import { TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import './Define.css'
import { formatNumber, removeComma } from "./defineUtils";

export default function TableCellWeek1(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, selectedDepletion } = define;
   const [week1, setWeek1] = useState(params.row.weekly1);
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   useEffect(()=>{
      setWeek1(params.row.weekly1);
   },[params.row.weekly1]);

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const updated = gridDataFiltered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly1: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < gridData.length; ++i) {
         const item = gridData[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      dispatch(setState("gridDataFiltered", updated));
      dispatch(setState("gridData", updatedGrid));
   }

   function updateWeek1(event) {
      let w1 = removeComma(event.target.value);
      w1 = Number(w1);
      let w2 = Number(params.row.weekly2);
      let hasError = false;
      setWeek1(w1);

      if (!w1 && w1 !== 0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }
      if (selectedDepletion.key === "biweekly") {
         if (w1 > w2) {
            hasError = true;
         }
      }
      if (w1 > w2) {
         hasError = true;
      }
      dispatch(setState("gridDataChanged", true));
      updateGrid(hasError, w1);
      dispatch(setTotalValues());
   }

   function handleValidity(w1, w2){
      if (selectedDepletion.key === "biweekly") {
         if (w1 > w2) {
            dispatch(setState("isError", true));
            dispatch(setState("isError_Info", "Must be less or equal to second half"));
         }
      }
      if (w1 > w2) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week2"));
      }
   }

   return (
      <TextField
         variant="standard"
         value={week1?.toLocaleString('en-US')}
         className={params.row.weekly1 > params.row.weekly2 ? 'red-row' : ''}
         onChange={updateWeek1}
         onBlur={() => {
            handleValidity(params.row.weekly1,params.row.weekly2 );
         }}
         sx={{ width: 100 }}
         inputProps={{ style: {textAlign: 'center' } }}
      />
   );
}
